<template>
    <div class="TQ_center">

        <!-- Title -->
        <div class="TQ_bg_white" v-if="co_currentCategoryData_o">

            <div class="TQ_align_initial TQ_text_20px TQ_padding_8px ">
                <tq-link class="TQ_text_remove_underline TQ_text_capitalize" :p_link_s="enum_moveToOptions.player_store"> {{ass_strings.oneWord_store[store_system_langCode_v.val]}}</tq-link>
                >
                <span class="TQ_text_bold TQ_text_capitalize">
                    {{ co_currentCategoryData_o.title_blc_s[store_system_langCode_v.val] }}
                </span>
            </div>

            <tq-on-top-container :style="{'background': `url(${co_currentCategoryData_o.img_r}`, backgroundPosition: 'center'}" class="TQ_height_300px">

                <h1 slot="middle" class="TQ_inline lc_title1 TQ_textColor_white TQ_font_SecularOne TQ_text_shadow TQ_text_capitalize">
                    {{co_currentCategoryData_o.title_blc_s[store_system_langCode_v.val]}}
                </h1>
            </tq-on-top-container>

            <h2 class="TQ_text_24px TQ_padding_16px">
                {{co_currentCategoryData_o.description_blc_s[store_system_langCode_v.val]}}
            </h2>
        </div>

        <!-- Quests -->
        <div class="TQ_padding_8px"></div>

        <!-- quests list -->
        <tq-loader-container :p_show-loader_b="showLoader_questsExplores_b" :p_tq-loader_b="true">

            <c_-player_-store_-list
                class="TQ_padding_8px"
                v-if="!showLoader_questsExplores_b && currentCategory_e"
                :p_more-quest-btn-loader_b="false"

                :p_link-prefix_e="enum_moveToOptions.player_store_category + '/' + currentCategory_e"

                :p_system-lang-code_e="store_system_langCode_v.val"
                :p_system-currency_e="store_system_currency_v.val"
                :p_system-window-size-type_e="store_system_windowSizeType_ve.val"
                :p_screen-width_n="store_screenWidth_vn.val"

                :p_creators-data_by-user-id_c="server_creatorData_byUserId_c"
                :p_loved-quests_by-quest-id_c="server_lovedQuests_byQuestId_c"
                :p_quest-explore-info_by-quest-id_c="server_questExploreInfo_byQuestId_c"
                :p_quests-explore_ac="server_questsExplore_ac"

                :p_show-map_b="currentCategory_e !== enum_questCategories.virtual"

                :pe_click-love-quest_f="m_clickLoveQuest_f"
            />
        </tq-loader-container>

    </div>
</template>

<script>
import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
import {ass_img_outdoor2, ass_img_selfGuided, ass_img_teamWork, ass_img_virtual} from "@/assets/scripts/Ass_Files";
import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
import C_Player_Store_List from "@/views/v_player/v_player_store/c_Player_Store_List";
import {store_getStateValue_vo, store_var} from "@/store";
import {
    server_getQuestExploreInfo_f,
    server_userLoveQuest_f,
    serverPre_cl_currentUserLovedQuests_get_f, serverPre_cl_currentUserLovedQuests_remove_f
} from "@/scripts/Server/S_ServerPre";
import {
    serverAuth_currentUserData_get_vl_fp,
    serverAuth_currentUserData_remove_vl_f,
    serverAuth_getOtherUserData_f
} from "@/scripts/Server/S_ServerAuth";
import {
    serverBig_questsExplore_getAll_f,
} from "@/scripts/Server/S_ServerFirestore";
import TqLink from "@/components/basic/TqLink";
import {
    enum_moveToOptions,
    enum_questCategories,
    enum_questLocationsTypes_s
} from "../../../../functions/src/shareCode/Share_S_Enum";
import {route_getCurrentFullPath_s} from "@/router";
import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
import {seo_updateDynamicValues_f} from "@/scripts/S_seo";
export default {
    name: "v_Player_Store_category",
    components: {TqLoaderContainer, TqLink, C_Player_Store_List, TqOnTopContainer, TqImgFillBlur},
    data(){
        return {

            showLoader_questsExplores_b         : true,
            enum_moveToOptions         : enum_moveToOptions,
            categories_ao : [
                {title_blc_s : ass_strings.oneWord_outside,          description_blc_s: ass_strings.sentence_storeDes_outside,       img_r : ass_img_outdoor2,   path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.outside},
                {title_blc_s : ass_strings.oneWord_virtual,          description_blc_s: ass_strings.sentence_storeDes_virtual,       img_r : ass_img_virtual,    path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.virtual},
                {title_blc_s : ass_strings.twoWords_teamBuilding,   description_blc_s: ass_strings.sentence_storeDes_teamBuilding,  img_r : ass_img_teamWork,   path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.teamWork},
                {title_blc_s : ass_strings.twoWords_selfGuided,     description_blc_s: ass_strings.sentence_storeDes_selfGuided,    img_r : ass_img_selfGuided, path_s : enum_moveToOptions.player_store_category + "/" + enum_questCategories.selfGuided},
            ],
            currentCategory_e : undefined,

            // store
            store_system_windowSizeType_ve      : store_getStateValue_vo(store_var.system_windowSizeType_e),
            store_system_langCode_v             : store_getStateValue_vo(store_var.system_langCode),
            store_system_currency_v             : store_getStateValue_vo(store_var.system_currency),
            store_storePath_vs                  : store_getStateValue_vo(store_var.player_storePath_s),
            store_screenWidth_vn                : store_getStateValue_vo(store_var.system_screenWidth),

            // server
            server_currentUserData_c            : undefined,
            server_questsExplore_ac             : [],
            server_creatorData_byUserId_c       : {},
            server_questExploreInfo_byQuestId_c : {},
            server_lovedQuests_byQuestId_c      : {},


            enum_questCategories : enum_questCategories,
            ass_strings : ass_strings
        }
    },
    computed : {
          co_currentCategoryData_o(){

              switch(this.currentCategory_e){

                  case enum_questCategories.outside:
                      return this.categories_ao[0]
                  case enum_questCategories.virtual:
                      return this.categories_ao[1]
                  case enum_questCategories.teamWork:
                      return this.categories_ao[2]
                  case enum_questCategories.selfGuided:
                      return this.categories_ao[3]
              }
          },

    },
    methods : {
        m_clickLoveQuest_f(questExplore_c){

            if(this.server_currentUserData_c == null){
                return
            }

            let lovedQuest_b = this.server_lovedQuests_byQuestId_c[questExplore_c.qex_questId_uid] != null;

            server_userLoveQuest_f(this.server_currentUserData_c.ud_userId_uid, questExplore_c, lovedQuest_b)
        },
    },
    created() {
        // 1) get currentUserData
        serverAuth_currentUserData_get_vl_fp(this.$options.name, (userData_c) => {

            this.server_currentUserData_c = userData_c

            if(userData_c == null){return}

            // 2) get currentUserLovedQuests
            serverPre_cl_currentUserLovedQuests_get_f(this.$options.name, userData_c,
                (questPointer_c) => {
                    this.$set(this.server_lovedQuests_byQuestId_c, questPointer_c.qp_questId_uid, questPointer_c)
                },
                () => {},
                (questId_uid) => {
                    this.$delete(this.server_lovedQuests_byQuestId_c,questId_uid)
                })
        })

    },
    activated() {
        let fullPath_s = route_getCurrentFullPath_s()
        let locationType_e = null
        let guidedQuest_b = null
        if(fullPath_s.includes(enum_questCategories.outside)){
            this.currentCategory_e = enum_questCategories.outside
            locationType_e = enum_questLocationsTypes_s.outside
        }else if(fullPath_s.includes(enum_questCategories.virtual)){
            this.currentCategory_e = enum_questCategories.virtual
            locationType_e = enum_questLocationsTypes_s.virtual
        }else if(fullPath_s.includes(enum_questCategories.teamWork)){
            this.currentCategory_e = enum_questCategories.teamWork
            guidedQuest_b = true
        }else if(fullPath_s.includes(enum_questCategories.selfGuided)){
            this.currentCategory_e = enum_questCategories.selfGuided
            guidedQuest_b = false
        }

        // seo update
        seo_updateDynamicValues_f({
            title_s         : this.co_currentCategoryData_o.title_blc_s[this.store_system_langCode_v.val],
            description_s   : this.co_currentCategoryData_o.description_blc_s[this.store_system_langCode_v.val],
            imagePath_s     : this.co_currentCategoryData_o.img_r
        })

        // 3) get questExplore
        this.showLoader_questsExplores_b = true
        serverBig_questsExplore_getAll_f({
            filterByActive_b: true,
            locationType_e : locationType_e,
            guidedQuest_b : guidedQuest_b,
            cb_f: (questExplore_ac)=>{
            this.server_questsExplore_ac = questExplore_ac
            this.showLoader_questsExplores_b = false

            questExplore_ac.forEach(questExplore_c => {

                // 4) get questExplore creatorUserData
                if(this.server_creatorData_byUserId_c[questExplore_c.qex_creatorId_uid] === undefined){
                    this.$set(this.server_creatorData_byUserId_c,questExplore_c.qex_creatorId_uid, null);

                    serverAuth_getOtherUserData_f(questExplore_c.qex_creatorId_uid, userData_c =>{
                        this.$set(this.server_creatorData_byUserId_c, questExplore_c.qex_creatorId_uid, userData_c);
                    })
                }

                // 5) get questExplore moreInfo
                server_getQuestExploreInfo_f(questExplore_c, (questExploreInfo_c) => {
                    this.$set(this.server_questExploreInfo_byQuestId_c, questExploreInfo_c.qexi_questId_uid, questExploreInfo_c)
                })
            });
        }});



    },
    destroyed(){
        serverAuth_currentUserData_remove_vl_f(this.$options.name)

        if(this.server_currentUserData_c){
            serverPre_cl_currentUserLovedQuests_remove_f(this.$options.name, this.server_currentUserData_c.ud_userId_uid)
        }

    }
}
</script>

<style scoped lang="scss">
    .lc_title1{
        font-size: 80px;
        -webkit-text-stroke: 0.5px black;
    }

</style>